<wl-top-banner
  *ngIf="title"
  (handleClickEvent)="onClick()"
  [hideLink]="multiItemQuotesCount === 0"
  [linkText]="linkText"
  [subtitle]="multiItemQuotesCount === 0 ? undefined : subtitle"
  [title]="title"
></wl-top-banner>
